import React from 'react';

export const renderPaginationShowsTotal = (start, to, total) => (
    <span style={{ display: 'inline-block', marginRight: '10px' }}>
        Displaying {start} to {to} of {total} in total.
    </span>
);
